import { RouteRecordRaw } from 'vue-router';
import profile from './profile';
import home from './home';
import assistenza from './assistenza';
import acquisti from './acquisti';
import shop from './shop';
import news from './news';
import network from './network';
import intro from './intro';
import clubSubscription from './clubSubscription';
import vacations from './vacations';
import agentSubscription from './agentSubscription';

export default (): Array<RouteRecordRaw> => {
    return [
        {
            path: '/network',
            name: 'network',
            component: () => import("./layout.vue"),
            children: [
                ...intro.routes(),
                ...home.routes(),
                ...assistenza.routes(),
                ...acquisti.routes(),
                ...shop.routes(),
                ...profile.routes(),
                ...news.routes(),
                ...network.routes(),
                ...clubSubscription.routes(),
                ...agentSubscription.routes(),
                ...vacations.routes()
            ],
            // beforeEnter: (to, from, next) => {
            //     if(to.name != 'clubSubscription' && to.name != 'categoryOffers' && to.name != 'buyOffer' && to.name != 'thankyou'){
            //         if(!store.state.clubSubscription){
            //             next("/network/clubSubscription");
            //         } else {
            //             next();
            //         }
            //     } else {
            //         next();
            //     }
            // }
        },
    ];
};